const removeSpecialChars = str =>{
	if(str){
		str = str.replaceAll('œ', 'oe');
		str = str.replaceAll('Œ', 'OE');
	}
	return str;
};

const removeKeysWithEmptyValue = object =>{
	Object.keys(object).forEach(key => {
		if (object[key] === null || object[key] === undefined || object[key] === '') {
			delete object[key];
		}
	});
	return object;
};

const parseIfNumber = value =>{
	if (typeof value === 'string' && value.trim() !== '' && !isNaN(value)) {
		const parsed = Number(value);
		if (Number.isInteger(parsed)) {
			return parsed;
		}
	}
	return value;
};

/* FORMAT DATE SO HUMANS CAN EASILY READ THEM */
const getReadableDate = isoDate => {
	let fullDate = isoDate.toLocaleDateString("fr-BE", {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit", 
		minute: "2-digit", 
		second: "2-digit"
	});
	return fullDate;
};

export { 
	removeSpecialChars, 
	removeKeysWithEmptyValue, 
	parseIfNumber,
	getReadableDate,
};